<template>
  <div
    ref="policyDocument"
    class="policy-document__container font-16 d-flex flex-wrap"
  >
    <div
      v-for="(doc, index) of policyDocumentRows"
      :key="index"
      class="document-wrapper"
    >
      <div class="document__item document__item--spacing">
        <div>
          <div class="d-flex flex-row-reverse download-icon__wrapper">
            <img
              class="logo"
              src="@/assets/icons/ic_file_download.svg"
              alt="close_icon"
              height="32"
            />
          </div>
          <h3>
            {{
              doc.shortTitle && $vuetify.breakpoint.mdAndDown
                ? doc.Name
                : doc.Name
            }}
          </h3>
        </div>
        <div>
          <BaseButton
            text="DOWNLOAD"
            height="48"
            depressed
            rounded
            block
            :color="'psorange'"
            class="font-weight-bold"
            className="btn-file-downloaded"
            fontSize="font-20"
            @click="downloadFile(doc)"
            :loading="doc?.isDownloading"
            loadingText="DOWNLOADING..."
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { downloadDocument } from "@/common/utils";
import BaseButton from "@/components/BaseComponents/BaseButton.vue";
import documentService from "@/services/document.service";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import { mapGetters } from "vuex";
export default {
  name: "PolicyDocument",
  components: {
    BaseButton,
  },
  props: {
    policyDocumentRows: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isDownloadError: false,
    };
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["httpConfig"]),
  },
  methods: {
    downloadFile(doc) {
      this.isDownloadError = false;
      if (doc.isDownloading) return;
      doc.isDownloading = true;

      documentService
        .getDocument(doc.Link, this.httpConfig)
        .then((res) => {
          downloadDocument(res, doc.Name);
          doc.isDownloading = false;
          doc.isDownloaded = true;
        })
        .catch((error) => {
          doc.isDownloading = false;
          doc.isDownloaded = false;
          this.isDownloadError = true;
          setTimeout(() => {
            const el = this.$refs.downloadError;
            if (el) {
              el.scrollIntoView({ behavior: "smooth" });
            }
          }, 500);
          console.error(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.policy-document__container {
  display: grid;
  grid-template-columns: auto auto;
  padding: 12px 22px;
}

.document-wrapper {
  padding: 4px 20px 20px;
  flex: 1;
  background: #fff;
  flex-wrap: nowrap;
  .document__item {
    padding: 35px 40px 49px;
    flex: 1;
    border-radius: 10px;
    background: #354048;
    color: #fff;
    border-radius: 10px;
    height: 100%;
    min-height: 340px;
    margin: 0 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    &--spacing {
      margin: auto;
    }
    p {
      padding: 32px 0 34px;
      font-size: 14px;
    }
    h4 {
      font-size: 14px;
      margin-top: -5px;
      font-weight: 600;
    }
    h3 {
      justify-content: space-between;
      font-weight: 600;
      max-height: 95px;
      max-width: 360px;
      font-size: 24px;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      .mdi-file {
        font-size: 35px;
      }
    }
    .v-btn {
      width: 100%;
      height: 48px;
      margin-top: 0;
      font-size: 20px !important;
    }
    .download-icon__wrapper {
      margin-top: -20px;
      margin-right: -14px;
      margin-bottom: 26px;
    }
  }
}

@media screen and (max-width: ($grid-breakpoints-md - 1)) {
  .document-wrapper {
    padding: 4px 0 20px 0;
  }
  .policy-document__container {
    grid-template-columns: auto;
  }
}
</style>
